import { observable, action, makeObservable } from 'mobx';
import agent from '../lib/agent';

class Store {
  questions = [
    {
      id: 'tax_liability',
      text: 'Do you have a tax liability?',
      type: 'checkbox',
      value: false
    },
    {
      id: 'non_profit',
      text: 'Is the company a non-profit ?',
      type: 'checkbox',
      value: false
    },
    {
      id: 'is_esco',
      text: 'Are you on an ESCO?',
      type: 'checkbox',
      value: false
    },
    {
      id: 'has_nat_gas',
      text: 'Do you have existing Natural Gas infrastructure?',
      type: 'checkbox',
      value: false
    },

    {
      id: 'gas_utility',
      text: 'Gas Utility Name',
      type: 'text',
      value: ''
    },
    {
      id: 'electric_rate',
      text: 'Current Electric rate',
      type: 'text',
      value: ''
    },
    {
      id: 'gas_rate',
      text: 'Current Gas rate',
      type: 'text',
      value: ''
    }
  ];

  setAnswer = (questionId, value) => {
    const idx = this.questions.findIndex(q => q.id === questionId);
    const question = this.questions[idx];

    if (question.type === 'checkbox') {
      this.questions[idx].value = Boolean(value);
    } else {
      this.questions[idx].value = value;
    }
  };

  setAnswers = answers => {
    if (!answers) {
      return;
    }

    answers.forEach(answer => {
      this.setAnswer(answer.id, answer.value);
    });
  };

  addSurvey = async projectId => {
    const answers = this.questions.map(({ id, value, checked }) => ({
      id,
      value,
      checked
    }));
    const { data } = await agent.Survey.addSurvey(projectId, {
      data: answers
    });
    return data;
  };

  constructor() {
    makeObservable(this, {
      questions: observable,
      setAnswer: action,
      setAnswers: action,
      addSurvey: action
    });
  }
}

const store = new Store();
export default store;
